

import EmailUtil from 'zunzun/flyutil/email.mjs'
import RSA from 'zunzun/flypto/rsa.mjs'
import StepForm from 'zunzun/flyhtml/step/form.mjs'
import URLUtil from 'zunzun/flyutil/url.mjs'

import raw_html from './html/signin.njk'
import lang from './lang.mjs'

export default class SignUp {
  constructor(config) {

    if (!config) config = {};
    const lkey = config.lang || "en"

    let form_steps = [
      {
        type: "text",
        name: "username",
        placeholder: lang[lkey].signup.placeholder.username,
        verify: async function(value, values, errcb, element) {
          try {
            console.log(value.match(/^[A-Za-z0-9_.-]+$/));
            if (value.match(/^[A-Za-z0-9_.-]+$/) && value.length > 1) {
              const extra_div = element.querySelector("div.step_form_extra");
              extra_div.innerHTML = "";
              return true;
            }
            errcb(lang[lkey].signup.error.invalid_username)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      },
      {
        type: "text",
        name: "email",
        placeholder: lang[lkey].signup.placeholder.email,
        verify: async function(value, values, errcb) {
          try {
            if (EmailUtil.validate(value)) {
              step_form.display_loading();
              
              const rsa = new RSA(FLYAUTH_PUBLIC_KEY.replace(/\\n/g, "\r\n"));
              await fetch('/flyauth/submit-email', {
                method: "PUT",
                body: "data="+rsa.encrypt(JSON.stringify({
                  username: values.username,
                  email: value
                }))
              }).then( response => response.text() );
              return true;
            }
            errcb(lang[lkey].signup.error.invalid_email)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      },
      {
        type: "text",
        name: "verification_code",
        placeholder: lang[lkey].signup.placeholder.verification_code,
        verify: async function(value, values, errcb) {
          try {
            console.log(value.length, value);
            if (value.length === 24) return true;
            errcb(lang[lkey].signup.error.invalid_code)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      },
      {
        type: "password",
        name: "password",
        placeholder: lang[lkey].signup.placeholder.pwd1,
        verify: async function(value, values, errcb) {
          try {
            if (value.length > 4) {
              return true;
            }
            errcb(lang[lkey].signup.error.pwd_too_short)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      },
      {
        type: "password",
        placeholder: lang[lkey].signup.placeholder.pwd2,
        verify: async function(value, values, errcb) {
          try {
            if (values["password"] === value) {
              step_form.display_loading();
              return true;
            }

            errcb(lang[lkey].signup.error.pwd_match)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      }
    ];


    const vcode = URLUtil.get_parameter('verification-code', window.location.href);
    if (vcode) {
      form_steps = form_steps.slice(3);
    }

    const step_form = new StepForm({
      instructions: lang[lkey].signup.instructions
    }, form_steps, async function(values) {
      step_form.display_loading();
      
      if (vcode) values.verification_code = vcode;

      const rsa = new RSA(FLYAUTH_PUBLIC_KEY.replace(/\\n/g, "\r\n"));

      await fetch('/flyauth/signup', {
        method: "PUT",
        body: `data=${rsa.encrypt(JSON.stringify(values))}`
      }).then( (response) => {
        if (!response.ok) {
          errcb("error!")
          return false;
        }

        return response.text() 
      });
      window.location.href = config.success_path;
    })


    this.element = step_form.element;
  }
}
